export default __webpack_public_path__ + "static/ui-ux-process_-from-concept-to-implementation-260b65ba06df0ee0c474749868b36dc1.png";